import {
    CORE_LOAD_SETTING_INFO_REQUEST,
    CORE_LOAD_SETTING_INFO_SUCCESS,
    CORE_LOAD_SETTING_INFO_FAILURE,

    CORE_CHANGE_SETTING_REQUEST,
    CORE_CHANGE_SETTING_SUCCESS,
    CORE_CHANGE_SETTING_FAILURE,

    CORE_CHECK_AD_REQUEST,
    CORE_CHECK_AD_SUCCESS,
    CORE_CHECK_AD_FAILURE,

    CORE_LOAD_TIMEZOZE_REQUEST,
    CORE_LOAD_TIMEZOZE_SUCCESS,
    CORE_LOAD_TIMEZOZE_FAILURE,

    CORE_CHECK_TMS_REQUEST,
    CORE_CHECK_TMS_SUCCESS,
    CORE_CHECK_TMS_FAILURE,

    CORE_CHECK_CMR_REQUEST,
    CORE_CHECK_CMR_SUCCESS,
    CORE_CHECK_CMR_FAILURE,

    CORE_CHECK_BOT_REQUEST,
    CORE_CHECK_BOT_SUCCESS,
    CORE_CHECK_BOT_FAILURE,
} from '../../types'

import { CALL_API } from 'Middlewares'
import { CORE_API_ENDPOINT } from 'Lib'

export function findSettingInfo() {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/setting/info`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            types: [
                CORE_LOAD_SETTING_INFO_REQUEST,
                {
                    type: CORE_LOAD_SETTING_INFO_SUCCESS,
                    payload(action, state, res) {
                        return res.json()
                            .then(json => {
                                return json.value
                            })
                    }
                },
                CORE_LOAD_SETTING_INFO_FAILURE
            ]
        }
    }
}
export function changeSetting(body, isUpdateLogo = false) {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/setting`,
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            types: [
                CORE_CHANGE_SETTING_REQUEST,
                {
                    type: CORE_CHANGE_SETTING_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(json => {
                                return json
                            })
                    },
                    callBack() {
                        window.location.reload()
                    }
                },
                CORE_CHANGE_SETTING_FAILURE
            ]
        }
    }
}

export function checkConnectAD(setting) {
    const {
        activeDirectoryAdminPassword,
        activeDirectoryAdminUser,
        activeDirectoryBaseDN,
        activeDirectoryIP,
        activeDirectoryPort
    } = setting
    const body = {
        "url": "ldap://" + activeDirectoryIP + ":" + activeDirectoryPort,
        "baseDN": activeDirectoryBaseDN,
        "username": activeDirectoryAdminUser,
        "password": activeDirectoryAdminPassword
    }

    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/user/verifyAD`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            types: [
                CORE_CHECK_AD_REQUEST,
                {
                    type: CORE_CHECK_AD_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(json => {
                                return json.value
                            })
                    },
                },
                CORE_CHECK_AD_FAILURE
            ]
        }
    }
}


export function checkConnectTMS(setting) {
    const {
        tms_server,
        tms_user,
        tms_password,
        tms_user_prefix,
        tms_conference_type
    } = setting
    const body = {
        tms_server: tms_server,
        tms_user: tms_user,
        tms_password: tms_password,
        tms_user_prefix: tms_user_prefix,
        tms_conference_type: tms_conference_type
    }

    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/setting/connectTMS`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            types: [
                CORE_CHECK_TMS_REQUEST,
                {
                    type: CORE_CHECK_TMS_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(json => {
                                return json.value
                            })
                    },
                },
                CORE_CHECK_TMS_FAILURE
            ]
        }
    }
}

export function checkConnectCMR(setting) {
    const {
        cmr_server_url,
        cmr_user,
        cmr_password,
        cmr_site_name
    } = setting
    const body = {
        cmr_server_url: cmr_server_url,
        cmr_user: cmr_user,
        cmr_password: cmr_password,
        cmr_site_name: cmr_site_name
    }
    
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/setting/connectCMR`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            types: [
                CORE_CHECK_CMR_REQUEST,
                {
                    type: CORE_CHECK_CMR_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(json => {
                                return json.value
                            })
                    },
                },
                CORE_CHECK_CMR_FAILURE
            ]
        }
    }
}

export function checkConnectBOT(setting) {
    const {
        bot_web_hook_url,
    } = setting
    const body = {
        bot_web_hook_url: bot_web_hook_url,
    }

    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/setting/connectBOT`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            types: [
                CORE_CHECK_BOT_REQUEST,
                {
                    type: CORE_CHECK_BOT_SUCCESS,
                    payload(action, state, res) {
                        return res
                            .json()
                            .then(json => {
                                return json.value
                            })
                    },
                },
                CORE_CHECK_BOT_FAILURE
            ]
        }
    }
}

export function loadAllTimeZone() {
    return {
        [CALL_API]: {
            endpoint: `${CORE_API_ENDPOINT}/timezone/list`,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            types: [
                CORE_LOAD_TIMEZOZE_REQUEST,
                {
                    type: CORE_LOAD_TIMEZOZE_SUCCESS,
                    payload(action, state, res) {
                        return res.json()
                            .then(json => {
                                return json.value
                            })
                    }
                },
                CORE_LOAD_TIMEZOZE_FAILURE
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/features/setting/actions.js